//#region src/pinata_pay_transaction_result.ts
const PinataPayTransactionResult = {
	Approval: "approval",
	Decline: "decline",
	PartialApproval: "partial_approval",
	ProcessingError: "processing_error",
	Invalid: "invalid",
	Cancelled: "cancelled",
	RefundFailure: "refund_failure",
	Delayed: "delayed"
};
//#endregion
export { PinataPayTransactionResult };

//# sourceMappingURL=pinata_pay_transaction_result.js.map